import { render, staticRenderFns } from "./ModalRegerarTermos.vue?vue&type=template&id=09a7f4e0&lang=pug"
import script from "./ModalRegerarTermos.vue?vue&type=script&lang=js"
export * from "./ModalRegerarTermos.vue?vue&type=script&lang=js"
import style0 from "./ModalRegerarTermos.vue?vue&type=style&index=0&id=09a7f4e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports